<script>
import {  common } from '@/mixins/common';
import { PostApiWithAuthorizationAction } from '../../../helpers/apiActions';
import draggable from "vuedraggable";

export default {
  name: 'AddNewAlbumDrawerContent',
  components: {
    draggable,
  },
  props: {
    album: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      uploadedPictures: [],
      submitted: false,
      form: {
        title: ''
      },
      rules: {
        title: [
          { required: true, message: ' ', trigger: 'change' }
        ]
      }
    }
  },
  mixins: [
    common
  ],
  methods: {
    getRandomId() {
      return new Date().getUTCMilliseconds();
    },
    onFilePicked (event) {
      const files = event.target.files
      const fileId = event.target.id.replace('fileInput_', '')
      //const _vm = this
      if (files.length > 0) {
        let file = files[0]
        let data = new FormData()
        //let uploadedPictures = _vm.uploadedPictures
        data.append('file', file, file.name)
        data.append('id', fileId)
        /*let loader = this.$loading.show({
          container: document.getElementById('uploadedFile' + fileId),
          loader: 'dots',
          color: '#409EFF'
        });
        return PostApiWithAuthorizationAction("", data, {
          'Content-Type': 'multipart/form-data',
          'url': process.env.VUE_APP_CYBERSHOP_V1_URL + "api/auction/replacePicture"
        }).then(res => {
          document.getElementById("uploadedThumb" + fileId).src = res.data['thumbnailUrl']
          let findIndex = uploadedPictures.findIndex(v=>v.id==fileId)
          // eslint-disable-next-line
          console.log(findIndex)
          if (findIndex > -1) {
            uploadedPictures[findIndex]['thumbnailUrl'] = res.data['thumbnailUrl']
            uploadedPictures[findIndex]['originalUrl'] = res.data['originalUrl']
            _vm.uploadedPictures = uploadedPictures
          }
          document.getElementById("fileInput_" + fileId).value= null;
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
        }).finally(() => {
          loader.hide()
        });*/
      }
    },
    // eslint-disable-next-line
    onFileSelected(file, fileList) {
      this.uploadedPictures = this.album.AuctionAttachments.concat(fileList)
    },
    updateList(pictures) {
      return PostApiWithAuthorizationAction("admin/products/sort-pictures", { pictures });
    },
    submitForm() {
        let _vm = this
        _vm.$refs.formContainer.validate((valid) => {
            if (valid) {
              _vm.submitted = true
              let data = new FormData()
              let uploadedPictures = _vm.uploadedPictures.filter(p => p.raw).map(p => p.raw)
              data.append('title', _vm.form.title)
              for (let uploadedPicture of uploadedPictures) {
                data.append('files[]', uploadedPicture, uploadedPicture.name)
              }
              let submitUrl = (_vm.album.id === 0)
                                ? process.env.VUE_APP_BACKEND_APP_URL + "admin/products/live-show/create-album"
                                : process.env.VUE_APP_BACKEND_APP_URL + "admin/products/live-show/edit-album/" + _vm.album.id
              return PostApiWithAuthorizationAction("", data, {
                'Content-Type': 'multipart/form-data',
                'url': submitUrl
              }).then(res => {
                if (res.status == 'success') {
                  location.href = '/products/live-show/index?tab=albums'
                }
                _vm.submitted = false
              }).catch(error => {
                // eslint-disable-next-line
                console.log(error)
                _vm.submitted = false
              })
            }
        });
    },
    beforeUploadPicture() {
      this.$toast.warning("Uploading Picture", {
          position: "bottom-right",
          timeout: false,
          closeOnClick: true,
          icon: "el-icon-loading",
      });
    },
    afterUpload(response, file, fileList) {
        this.$toast.clear();
        if (response.status == "success") {
            let uid = file.uid;
            let findIndex = fileList.findIndex((f) => f.uid == uid);
            fileList[findIndex].url = response.imageUrls[0].thumbnailWatermarkedUrl;
            fileList[findIndex].origUrl = response.imageUrls[0].watermarkedUrl;
            fileList[findIndex].id = response.imageUrls[0].id;
            fileList[findIndex].appId = response.imageUrls[0].appId;
            fileList[findIndex].thumbnailUrl = response.imageUrls[0].thumbnailWatermarkedUrl;
            this.uploadedPictures = this.uploadedPictures.concat(fileList);
        }
    },
    handlePicturePreview(file) {
      window.open(file.origUrl, "_blank").focus();
    },
    handlePictureRemove(file) {
      if (confirm("Are you sure that you want delete this picture ?")) {
        let _vm = this;
        let loader = this.$loading.show({
          container: document.getElementById("uploadedFile" + file.id),
          loader: "dots",
          color: "#409EFF",
        });
        PostApiWithAuthorizationAction("admin/products/live-show/delete-pictures", {
          url: file.url,
        })
          .then(() => {
            document.getElementById("el-upload-list__item_" + file.id).remove();
            loader.hide();
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error);
            loader.hide();
            _vm.$toast.error(error.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true,
            });
          });
      }
    },
  },
  computed: {
    uploadPictureActionUrl() {
      return process.env.VUE_APP_BACKEND_APP_URL + "admin/products/live-show/upload-album-photos";
    },
    uploadPictureHeaders() {
        let user = JSON.parse(localStorage.getItem("user"));
        return {
            Authorization: `Bearer ${user.token}`,
        };
    },
    uploadedData() {
      return {
        id: this.album.id,
      };
    },
  },
  mounted () {
    let _vm = this;
    _vm.form.title = _vm.album.title;
    _vm.uploadedPictures = _vm.album.AuctionAttachments
  }
}
</script>

<template>
<div class="px-2" style="overflow: hidden">
    <el-form
        :model="form"
        @submit.native.prevent="submitForm"
        ref="formContainer"
        id="identifierForm">
        <el-form-item
          class="mb-4"
          :rules="rules.title"
          prop="title">
          <label
            class="mb-0"
            style="display: block;line-height: 15px;">Album Title</label>
          <el-input
            placeholder=""
            v-model="form.title"
            style="width: 50%;"
            autofocus="autofocus"
            size="medium">
          </el-input>
        </el-form-item>
        <div class="box-section mb-3">
          <div class="box-section-header">PICTURES</div>
          <div class="box-section-body pt-1">
            <div class="text-center">
              <draggable
                v-model="uploadedPictures"
                @start="drag = true"
                @end="drag = false"
                @update="updateList(uploadedPictures)"
                class="el-upload-list el-upload-list--picture-card"
              >
                <div
                  :class="['el-upload-list__item']"
                  :id="'el-upload-list__item_' + file.id"
                  v-for="(file, index) in uploadedPictures"
                  :key="index"
                >
                  <div :ref="'uploadedFile' + file.id" :id="'uploadedFile' + file.id">
                    <!--el-button
                      icon="fas fa-compress"
                      size="mini"
                      type="warning"
                      v-show="!file.url.includes('blob')"
                      class="shift-picture-btn handle"
                      circle
                    ></el-button-->
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="
                        (file.thumbnailUrl || file.url) +
                        (!file.url.includes('blob') ? '?id=' + getRandomId() : '')
                      "
                      alt=""
                      :id="'uploadedThumb' + file.id"
                      draggable="true"
                      ondragstart="onDragStart(event);"
                    />
                    <span class="el-upload-list__item-actions text-center">
                      <el-button-group style="margin-top: 25px">
                        <!--el-button
                          icon="el-icon-zoom-in"
                          size="mini"
                          type="primary"
                          @click="handlePicturePreview(file)"
                          circle
                        ></el-button-->
                        <el-button
                          size="mini"
                          icon="el-icon-delete"
                          type="danger"
                          @click="handlePictureRemove(file, uploadedPictures)"
                          circle
                        ></el-button>
                        <!--el-button
                          type="success"
                          icon="fas fa-undo"
                          circle
                          size="mini"
                          @click="handlePictureRotatePrevious(file)"
                        ></el-button>
                        <el-button
                          type="success"
                          icon="fas fa-redo"
                          circle
                          size="mini"
                          @click="handlePictureRotateNext(file)"
                        ></el-button>
                      </el-button-group>
                      <el-button-group style="margin-top: -80px">
                        <input
                          type="file"
                          :id="'fileInput_' + file.id"
                          accept="image/png, image/jpeg"
                          @change="onFilePicked"
                          hidden
                        />
                        <el-button
                          type="warning"
                          icon="fas fa-edit"
                          circle
                          size="mini"
                          @click="handlePictureReplace(file.id)"
                        ></el-button>
                        <el-button
                          type="primary"
                          icon="fas fa-plus"
                          circle
                          size="mini"
                        ></el-button-->
                      </el-button-group>
                    </span>
                  </div>
                </div>
              </draggable>
              <el-upload
                :action="uploadPictureActionUrl"
                :headers="uploadPictureHeaders"
                :auto-upload="false"
                :data="uploadedData"
                :before-upload="beforeUploadPicture"
                :on-success="afterUpload"
                :on-error="afterUpload"
                :on-change="onFileSelected"
                :drag="true"
                :show-file-list="false"
                accept="image/png, image/jpeg"
                style="display: inline"
                name="files[]"
                multiple
                list-type="picture-card"
              >
                <span slot="default">
                  <el-button
                    size="small"
                    type="primary"
                    icon="el-icon-plus"
                    style="color: white; font-size: 20px"
                    circle
                  >
                  </el-button>
                </span>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="mt-2 text-right">
            <el-button
                type="primary"
                native-type="submit"
                :disabled="form.title === '' || submitted">
                SAVE ALBUM
            </el-button>
        </div>
    </el-form>
</div>
</template>
<style scoped>
.b-table {
    background-color: rgba(0, 0, 0, 0.05);
    border: 5px solid #5b5f70;
}
</style>
<style>
.el-upload-list--picture-card .el-upload-list__item,
.el-upload.el-upload--picture-card {
  width: 100px;
  height: 100px;
}
.el-upload--picture-card .el-upload-dragger {
  width: 100% !important;
  height: 100% !important;
}
.el-upload--picture-card {
  line-height: 100px;
}
</style>
